import { useState, useEffect, useRef, useContext } from 'react';
// import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { OpenSwal } from '../../Utils';
import Swal from 'sweetalert2';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useNavigate } from 'react-router-dom';
import { Button, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FormHelperText from '@mui/material/FormHelperText';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import FileViewerCustom from '../FileViewerCustom';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SignatureCanvas from 'react-signature-canvas';
// import { useSnackbar } from 'notistack';
import { url_store_datas, url_change_assignment_status, url_cancel_assignment,url_reject_interp_signature } from '../../RoutesMap';
import { AuthContext } from '../../Context/AuthProvider';
import { apiWithAuth } from '../../Services/Axios/axios';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

// import { useSelector, useDispatch } from 'react-redux';
// import {SetInterpretedDuration} from '../../Redux/Interpreter/AssignmentStartEndIntDuration';
dayjs.extend(utc);
dayjs.extend(timezone);


function AssignmentEndPage1({ assign_id, AssignmentStartdateTime, AssignmentDetailsAry, AssignmentDetailsAryAllSet, AssignmentEndPageDetailsSet, AssignmentEndPageDetails, assignmentTimeValidationError, changeAssignStatus, AssignmentCurrentPostStatus, AssignmentCancelReasonCancellationCode,isVerificationPage }) {
    const { currentUser } = useContext(AuthContext);
    let interpreter_start_time = AssignmentStartdateTime.interpreter_time;

    // let interpreter_start_time_dayjstz = dayjs.tz(interpreter_start_time).add('1', 'minute');
    const iti_user_timezone = currentUser['custom:user_timezone'];
    dayjs.tz.setDefault(iti_user_timezone);
    // let interpreter_current_time = dayjs.tz(new Date());
    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;

    const [endAssignmentStage, endAssignmentStageSet] = useState(null);

    const [currentUserTime, currentUserTimeSet] = useState(null);
    // const [datetimePickerMaxTime, datetimePickerMaxTimeSet] = useState(interpreter_current_time);
    const [datetimePickerDisabled, datetimePickerDisabledSet] = useState(false);
    const [datetimePickerHideShow, datetimePickerHideShowSet] = useState(false);
    const [datetimePickerErrorMsg, datetimePickerErrorMsgSet] = useState(false);

    const [AssignmentStartDateLapsed, AssignmentStartDateLapsedSet] = useState((AssignmentDetailsAry.assign_requestdatetime_interpreter) ? dayjs.tz(AssignmentDetailsAry.assign_requestdatetime_interpreter) : null);
    const [AssignmentStartDateLapsedErrorMsg, AssignmentStartDateLapsedErrorMsgSet] = useState(false);
    const [AssignmentEndDateLapsed, AssignmentEndDateLapsedSet] = useState((AssignmentDetailsAry.assign_time_lapsed_data.time_lapsed_status === 'Yes') ?
        dayjs.tz(AssignmentDetailsAry.assign_time_lapsed_data.request_date_time_duration_added_interpreter) : dayjs.tz(new Date(dayjs().format('YYYY-MM-DD hh:mm A'))));
    const [AssignmentEndDateLapsedErrorMsg, AssignmentEndDateLapsedErrorMsgSet] = useState(false);
    const [AssignmentTravelledStartedCheckboxStatus, AssignmentTravelledStartedCheckboxStatusSet] = useState(false);
    // const dispatch = useDispatch();


    // console.log(AssignmentTravelledStartedCheckboxStatus);

    const [closureTypeErrorMsg, closureTypeErrorMsgSet] = useState(false);
    const [assignmentPaperWorkFileError, assignmentPaperWorkFileErrorSet] = useState(false);
    const [PaperWorkFilesData, PaperWorkFilesDataSet] = useState({ blob: null, type: null, size: null });
    const [ManualCompletetionSelectValue, ManualCompletetionSelectValueSet] = useState('');
    const [ConsumerNoShowchecked, ConsumerNoShowcheckedSet] = useState(false);
    const [ClientCancelOnArrivalchecked, ClientCancelOnArrivalcheckedSet] = useState(false);
    const [ConsumerNoShowErrorMsg, ConsumerNoShowErrorMsgSet] = useState(false);
    const [ClientCancelOnArrivalErrorMsg, ClientCancelOnArrivalErrorMsgSet] = useState(false);
    // const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    //sched-1436-starts
    const [UploadSignedVoucher, setUploadSignedVoucher] = useState(false);
    const [ClientSignchecked, setClientSignchecked] = useState(false); //sched-1436
    const [clientSignatureReason, setClientSignatureReason] = useState("");
    const [clientSignatureReasonError, setClientSignatureReasonError] = useState("");

    const [clientCustomerName, setClientCustomerName] = useState('');
    const [clientCustomerNameError, setClientCustomerNameError] = useState(false);
    const [clisignatureEmptyError, clisignatureEmptyErrorSet] = useState(false); //sched-1436
    const clisigCanvas = useRef({}); //sched-1436
    const [closureType, closureTypeSet] = useState("Now");

    //sched-1436-ends





    const [manualCompletionRemarksErrormsg, manualCompletionRemarksErrormsgSet] = useState(false);
    const [manualCompletionRemarksShowHide, manualCompletionRemarksShowHideSet] = useState(false);
    const [manualCompletionOtherRemarksErrormsg, manualCompletionOtherRemarksErrormsgSet] = useState(false);
    const [signatureEmptyError, signatureEmptyErrorSet] = useState(false);
    const [finalEndAssignmentButtonLoading, finalEndAssignmentButtonLoadingSet] = useState(false);



    const sigCanvas = useRef({});


    const CheckEndAssignmentValid = (status) => {
        if (status === 'end_check') {
            let current_date_time_int = new Date(new Date().toLocaleString("en-US", { timeZone: iti_user_timezone }));
            let interpreter_start_time_dayjs = dayjs(interpreter_start_time).add('1', 'minute');
            if (Date.parse(current_date_time_int) > Date.parse(new Date(interpreter_start_time_dayjs))) {
                endAssignmentStageSet('end_assignment_start');
            } else {
                console.log(current_date_time_int, new Date(interpreter_start_time_dayjs));
                OpenSwal('Axios_error', 'You are not allowed to end the assignment after immediate start. Please wait atleast a minute time to complete');
            }
        } else if (status === 'go_back') {

            let payload = {
                assignid: assign_id,
                status: 'remove_end_datetime',
            }
            if (AssignmentCurrentPostStatus === 'Lapsed') {
                payload = { ...payload, status: 'remove_start_end_datetime' };
            }
            apiWithAuth.post(url_store_datas, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    AssignmentDetailsAryAllSet({ ...AssignmentDetailsAry, assign_interpreted_duration: "" })
                    AssignmentEndPageDetailsSet({ assign_endtime: '', checkout_type: '', paperwork_path: '', assign_startime: '' });
                    endAssignmentStageSet('end_assignment_start');
                } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
                else OpenSwal('Axios_error', response.data.message);
            }).catch(response => OpenSwal('Axios_error', response.message));

        }

    }
     // sched-1436-starts
    //  const getScheduledEndTime = () => {

    //     const requestedDateTime = dayjs(
    //         AssignmentDetailsAry.assign_requestdatetime
    //     );
    
    //     const duration = String(
    //         AssignmentDetailsAry.assign_duration || "0"
    //     ).trim();
    
    //     let scheduledEndTime;
    
    //     if (duration.includes(":")) {
    
    //         const [hours, minutes] = duration
    //             .split(":")
    //             .map(Number);
    
    //         scheduledEndTime = requestedDateTime
    //             .add(hours || 0, "hour")
    //             .add(minutes || 0, "minute");
    
    //     } else {
    
    //         scheduledEndTime = requestedDateTime.add(
    //             parseInt(duration, 10) || 0,
    //             "minute"
    //         );
    //     }
    
    //     return scheduledEndTime;
    // };
    // useEffect(() => {

    //     const scheduledEndTime = getScheduledEndTime();
    
    //     currentUserTimeSet(scheduledEndTime);
    
    //     // Scheduled = display only
    //     datetimePickerDisabledSet(true);
    //     datetimePickerHideShowSet(true);
    
    // }, [
    //     AssignmentDetailsAry.assign_requestdatetime,
    //     AssignmentDetailsAry.assign_duration
    // ]);
    const getScheduledEndTime = () => {
        const requestedDateTime = dayjs.tz(
            AssignmentDetailsAry.assign_requestdatetime,
            "MM/DD/YYYY hh:mm A",
            iti_user_timezone
        );
    
        const duration = String(
            AssignmentDetailsAry.assign_duration || "0"
        ).trim();
    
        let hours = 0;
        let minutes = 0;
    
        const hoursMatch = duration.match(/(\d+)\s*Hrs?/i);
        const minutesMatch = duration.match(/(\d+)\s*Mins?/i);
    
        if (hoursMatch) {
            hours = parseInt(hoursMatch[1], 10) || 0;
        }
    
        if (minutesMatch) {
            minutes = parseInt(minutesMatch[1], 10) || 0;
        }
    
        // Support HH:MM format
        if (!hoursMatch && !minutesMatch && duration.includes(":")) {
            const [durationHours, durationMinutes] = duration
                .split(":")
                .map(Number);
    
            hours = durationHours || 0;
            minutes = durationMinutes || 0;
        }
    
        // Support plain minutes, e.g. "30"
        if (
            !hoursMatch &&
            !minutesMatch &&
            !duration.includes(":")
        ) {
            minutes = parseInt(duration, 10) || 0;
        }
    
        return requestedDateTime
            .add(hours, "hour")
            .add(minutes, "minute");
    };
    useEffect(() => {
        const currentTime = dayjs.tz();
        const scheduledEndTime = getScheduledEndTime();
    
        console.log(
            "Current Time:",
            currentTime.format("YYYY-MM-DD hh:mm A Z")
        );
    
        console.log(
            "Scheduled End Time:",
            scheduledEndTime.format("YYYY-MM-DD hh:mm A Z")
        );
    
        if (currentTime.valueOf() >= scheduledEndTime.valueOf()) {
    
            // Duration has lapsed
            closureTypeSet("Scheduled");
            currentUserTimeSet(scheduledEndTime);
    
        } else {
    
            // Still within assignment duration
            closureTypeSet("Now");
            currentUserTimeSet(currentTime);
        }
    
        datetimePickerDisabledSet(true);
        datetimePickerHideShowSet(true);
    
    }, [
        AssignmentDetailsAry.assign_requestdatetime,
        AssignmentDetailsAry.assign_duration
    ]);
    // sched-1436-ends

    const ClosureType = (env) => {

        const value = env.target.value;
    
        closureTypeSet(value);
    
        const scheduledEndTime = getScheduledEndTime();
    
        if (value === "Scheduled") {
    
            currentUserTimeSet(scheduledEndTime);
    
            // Scheduled cannot be edited
            datetimePickerDisabledSet(true);
    
        } else if (value === "Now") {
    
            currentUserTimeSet(dayjs.tz());
    
            // Now cannot be edited
            datetimePickerDisabledSet(true);
    
        } else if (value === "Other") {
    
            // Earlier initially shows scheduled end time
            currentUserTimeSet(scheduledEndTime);
    
            // Earlier can be edited
            datetimePickerDisabledSet(false);
        }
    
        datetimePickerErrorMsgSet(false);
        datetimePickerHideShowSet(true);
    };

    const getDateTimePickerValidationMsg = (error) => {
        let msg = false;
        
        if (error === null) {
            msg = false;
        } else if (error === "minTime" || error === "minDate" || error === "minDateTime") {
            msg = "End Date & Time must be later than or equal to Start Date & Time.";
        } else if (error === "maxTime" || error === "maxDate" || error === "maxDateTime") {
            msg = "Start Date & Time must be earlier than or equal to End Date & Time.";
        } else if (error === "disableFuture") {
            msg = "Future dates and times are not allowed.";
        } else {
            msg = "Please enter a valid date and time.";
        }
        
        return msg;
       
        
        };
    const endAssignmentNext = () => {
        let validation_check = true;
        let paper_work_blob_path = "";
        let closure_type;

        ConsumerNoShowErrorMsgSet(false);
        ClientCancelOnArrivalErrorMsgSet(false);
        if (AssignmentCurrentPostStatus === 'Check In') {
            closure_type = document.querySelector("input[name='closure_type']:checked");
            if (!closure_type) {
                validation_check = false;
                closureTypeErrorMsgSet(true);
            } else {
                closureTypeErrorMsgSet(false);
            }
            if (datetimePickerErrorMsg !== false) {
                validation_check = false;
            }
        } else if (AssignmentCurrentPostStatus === 'Lapsed') {
            if (AssignmentEndDateLapsedErrorMsg !== false || AssignmentStartDateLapsedErrorMsg !== false) {
                validation_check = false;
            }
        }


        // sched-1436-starts
        // if ((AssignmentDetailsAry.service_type === "InPerson Interpretation") && (assignmentPaperWorkFileError !== 'ok')) {
        //     assignmentPaperWorkFileErrorSet('Please Upload paper work file');
        //     validation_check = false;
        // } else if (AssignmentDetailsAry.service_type === "InPerson Interpretation") {
        //     paper_work_blob_path = PaperWorkFilesData.blob;
        //     assignmentPaperWorkFileErrorSet('ok');
        // }
        if (
            AssignmentDetailsAry.service_type === "InPerson Interpretation" &&
            UploadSignedVoucher &&
            assignmentPaperWorkFileError !== "ok"
        ) {
            assignmentPaperWorkFileErrorSet("Please upload the signed voucher");
            validation_check = false;
        }
        else if (
            AssignmentDetailsAry.service_type === "InPerson Interpretation" &&
            UploadSignedVoucher
        ) {
            paper_work_blob_path = PaperWorkFilesData.blob;
            assignmentPaperWorkFileErrorSet("ok");
        }
        // sched-1436-ends
        if (ConsumerNoShowchecked === true) {
            let consumer_no_show_remarks = document.getElementById('consumer_no_show_remarks').value;
            if (consumer_no_show_remarks === "") {
                validation_check = false;
                ConsumerNoShowErrorMsgSet('Please enter the Remarks');
            }
        }
        if (ClientCancelOnArrivalchecked === true) {
            let client_cancel_on_arrival_remarks = document.getElementById('client_cancel_on_arrival_remarks').value;
            if (client_cancel_on_arrival_remarks === "") {
                validation_check = false;
                ClientCancelOnArrivalErrorMsgSet('Please enter the Remarks');
            }
        }
        if (validation_check) {
            let payload;
            let assign_end_date_time_show, assign_start_date_time_show;
            let Apply_local_time_state_status = localStorage.getItem('Apply_local_time_state');
            if (AssignmentCurrentPostStatus === 'Check In') {
                //                 assign_end_date_time_show = currentUserTime;
                // //console.log(Apply_local_time_state_status);
                //                 if (!Apply_local_time_state_status) {
                //                     assign_end_date_time_show = dayjs(currentUserTime).tz(AssignmentDetailsAry.assign_client_timezone);
                //                 }
                //                 Sched-1436
                assign_end_date_time_show = currentUserTime;

                // Format it for sending, don't convert timezone again
                if (!Apply_local_time_state_status) {
                    assign_end_date_time_show = currentUserTime.format("YYYY-MM-DD HH:mm:ss");
                } else {
                    assign_end_date_time_show = currentUserTime.local().format("YYYY-MM-DD HH:mm:ss");
                }

                payload = {
                    assignid: assign_id,
                    status: 'store_end_datetime',
                    end_date_time: dayjs(currentUserTime).format('YYYY-MM-DD hh:mm A')
                }
            } else if (AssignmentCurrentPostStatus === 'Lapsed') {
                assign_start_date_time_show = AssignmentStartDateLapsed;
                assign_end_date_time_show = AssignmentEndDateLapsed;
                if (!Apply_local_time_state_status) {
                    assign_start_date_time_show = dayjs(AssignmentStartDateLapsed).tz(AssignmentDetailsAry.assign_client_timezone);
                    assign_end_date_time_show = dayjs(AssignmentEndDateLapsed).tz(AssignmentDetailsAry.assign_client_timezone);
                }
                payload = {
                    assignid: assign_id,
                    status: 'store_start_end_datetime',
                    start_date_time: dayjs(AssignmentStartDateLapsed).format('YYYY-MM-DD hh:mm A'),
                    end_date_time: dayjs(AssignmentEndDateLapsed).format('YYYY-MM-DD hh:mm A'),
                }


            }
            apiWithAuth.post(url_store_datas, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    if (AssignmentCurrentPostStatus === 'Lapsed') {
                        AssignmentEndPageDetailsSet({
                            assign_endtime: assign_end_date_time_show,
                            checkout_type: 'Other',
                            paperwork_path: paper_work_blob_path,
                            assign_startime: assign_start_date_time_show
                        });
                    } else if (AssignmentCurrentPostStatus === 'Check In') {
                        AssignmentEndPageDetailsSet({
                            assign_endtime: assign_end_date_time_show,
                            checkout_type: closure_type.value,
                            paperwork_path: paper_work_blob_path,
                            assign_startime: AssignmentEndPageDetails.assign_startime || AssignmentStartdateTime.applied_startime,
                        });
                    }
                    // dispatch(SetInterpretedDuration());
                    // console.log(AssignmentDetailsAry);
                    AssignmentDetailsAryAllSet({ ...AssignmentDetailsAry, assign_interpreted_duration: response.data.interpreter_duration })
                    endAssignmentStageSet('end_assignment_manual_final');
                } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
                else OpenSwal('Axios_error', response.data.message);
            }).catch(response => OpenSwal('Axios_error', response.message));
        }
    }
    const assignPaperWorkFileUpload = () => {
        let paper_work_file = document.getElementById('assign_paper_work_file');
        if (paper_work_file.files[0]) {
            let filename = paper_work_file.files[0].name;
            let filename_extension_full = filename.split('.').pop();
            let filename_extension = filename_extension_full.toLowerCase();
            PaperWorkFilesDataSet({ blob: null, type: null, size: null });
            if (paper_work_file.files[0].size <= '10000000') {
                if (filename_extension === 'png' || filename_extension === 'jpg' || filename_extension === 'jpeg' || filename_extension === 'pdf') {
                    // fileReader.onload = (e) => {
                    PaperWorkFilesDataSet(
                        { blob: URL.createObjectURL(paper_work_file.files[0]), type: filename_extension, size: null }
                    );
                    assignmentPaperWorkFileErrorSet('ok');
                } else {
                    assignmentPaperWorkFileErrorSet(filename_extension + ' file type is not acceptable');
                }
            } else {
                assignmentPaperWorkFileErrorSet('Please ensure your file size does not exceed 10 MB');
            }
        }



    }
    const manualReasonSelect = (element) => {
        let value = element.target.value;
        ManualCompletetionSelectValueSet(value);
        if (value === 'Others') {
            manualCompletionOtherRemarksErrormsgSet(false);
            manualCompletionRemarksShowHideSet(true);
        } else {
            manualCompletionRemarksShowHideSet(false);
        }

    }
    const signatureCanvasClear = () => sigCanvas.current.clear();
    const clisignatureCanvasClear = () => clisigCanvas.current.clear();//sched-1436

    const endAssignmentFinal = () => {
        let validation_check = true;
        
        if (AssignmentCurrentPostStatus === 'Check In') {
            const startDateTime = dayjs(AssignmentEndPageDetails.assign_startime || AssignmentStartdateTime.applied_startime);
            const endDateTime = dayjs(AssignmentEndPageDetails.assign_endtime || currentUserTime);
            const minStartDateTime = dayjs(AssignmentDetailsAry.assign_requestdatetime).subtract(15, 'minute');
            const maxEndDateTime = dayjs(AssignmentDetailsAry.assign_requestdatetime)
                .add(parseInt(AssignmentDetailsAry.assign_duration), 'minute')
                .add(24, 'hour');

            if (
                assignmentTimeValidationError ||
                !startDateTime.isValid() ||
                !endDateTime.isValid() ||
                startDateTime.isBefore(minStartDateTime) ||
                startDateTime.isAfter(dayjs()) ||
                endDateTime.isBefore(startDateTime) ||
                endDateTime.isAfter(maxEndDateTime)
            ) {
                OpenSwal('Axios_error', 'Please correct the Assignment Start Time and Assignment End Time before submitting.');
                return;
            }
        }
        if (!isVerificationPage && !UploadSignedVoucher) {



            if (sigCanvas.current.isEmpty()) {
                signatureEmptyErrorSet(true);
                validation_check = false;
            } else {
                signatureEmptyErrorSet(false);
            }
        } else {

            signatureEmptyErrorSet(false);

        }
        // Client Signature Mandatory ONLY when checkbox checked sched-1436-starts
        if (
            !isVerificationPage &&
            AssignmentCurrentPostStatus === "Check In" &&
            AssignmentDetailsAry.service_type === "InPerson Interpretation" &&
            !UploadSignedVoucher
        ) {

            if (!ClientSignchecked && clientCustomerName.trim() === "") {
                setClientCustomerNameError(true);
                validation_check = false;
            } else {
                setClientCustomerNameError(false);
            }
        
            if (ClientSignchecked) {
        
                if (clientSignatureReason === "") {
        
                    setClientSignatureReasonError(
                        "Please select a reason."
                    );
        
                    validation_check = false;
        
                } else {
        
                    setClientSignatureReasonError("");
                }
        
                clisignatureEmptyErrorSet(false);
        
            } else {
        
                if (
                    !clisigCanvas.current ||
                    typeof clisigCanvas.current.isEmpty !== "function" ||
                    clisigCanvas.current.isEmpty()
                ) {
        
                    clisignatureEmptyErrorSet(true);
                    validation_check = false;
        
                } else {
        
                    clisignatureEmptyErrorSet(false);
                }
        
                setClientSignatureReasonError("");
            }
        
        }
        else {
        
            clisignatureEmptyErrorSet(false);
            setClientSignatureReasonError("");
        }
        // sched-1436-ends

        if (validation_check) {


            if (AssignmentDetailsAry.service_type === "InPerson Interpretation") {

                if (!navigator.geolocation) {
                    // notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Geolocation is Not Supported in your browser", variant: 'error' });
                    FinalSubmitFunc('', '');
                } else {
                    finalEndAssignmentButtonLoadingSet(true);
                    navigator.geolocation.getCurrentPosition(function (position) {
                        FinalSubmitFunc(position.coords.latitude, position.coords.longitude);
                    }, function (error) {
                        // finalEndAssignmentButtonLoadingSet(false);
                        // if (error.code === 1) {
                        //     notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Please turn on the location Permission", variant: 'error' });
                        // } else {
                        //     notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: error.message, variant: 'error' });
                        // }
                        FinalSubmitFunc('', '');
                    });
                }
            } else {
                FinalSubmitFunc('', '');
            }

        }
    }

    const FinalSubmitFunc = (latitude, longitude) => {
        finalEndAssignmentButtonLoadingSet(true);
        let manual_reason_other_remarks = document.getElementById('manual_reason_other_remarks');
        let formdata = new FormData();
        formdata.append('assignid', assign_id);
        formdata.append(
            'client_customer_name',
            clientCustomerName.trim()
        );
        if (isVerificationPage) {

            formdata.append('pagestatus', 'verification');
            formdata.append('travel_status', false);
            formdata.append('closure_type', 'Other');
        
        } else if (AssignmentCurrentPostStatus === 'Check In') {
            let closure_type = document.querySelector("input[name='closure_type']:checked");
            const startDateTime = AssignmentEndPageDetails.assign_startime || AssignmentStartdateTime.applied_startime;
            const endDateTime = AssignmentEndPageDetails.assign_endtime || currentUserTime;
            formdata.append('status', 'Check Out');
            //formdata.append('end_date_time', dayjs(currentUserTime).format('YYYY-MM-DD hh:mm A'));
            formdata.append('start_date_time', dayjs(startDateTime).format('YYYY-MM-DD hh:mm A'));
            formdata.append('end_date_time', dayjs(endDateTime).format('YYYY-MM-DD hh:mm A'));
            formdata.append('travel_status', false);
            formdata.append('closure_type', closure_type.value);
        } else if (AssignmentCurrentPostStatus === 'Lapsed') {
            formdata.append('status', 'Lapsed Check Out');
            formdata.append('start_date_time', dayjs(AssignmentStartDateLapsed).format('YYYY-MM-DD hh:mm A'));
            formdata.append('end_date_time', dayjs(AssignmentEndDateLapsed).format('YYYY-MM-DD hh:mm A'));
            formdata.append('travel_status', AssignmentTravelledStartedCheckboxStatus);
            formdata.append('closure_type', 'Other');
        } 
        formdata.append('latitude', latitude);
        formdata.append('longitude', longitude);

       //sched-1436-starts
       if ((AssignmentDetailsAry.service_type === "InPerson Interpretation") && UploadSignedVoucher) {
        let assign_paper_work_file = document.getElementById("assign_paper_work_file");
        formdata.append('paperwork_file', assign_paper_work_file.files[0]);
    }
    //sched-1436-ends
        // formdata.append('manual_reason_select', ManualCompletetionSelectValue);
        // formdata.append('manual_reason_other_remarks', manual_reason_other_remarks.value);
        formdata.append('checkout_type', 'manual');
        if (ConsumerNoShowchecked) {
            formdata.append('Consumer_no_show_status', 'Yes');
            let consumer_no_show_remarks = document.getElementById('consumer_no_show_remarks');
            formdata.append('consumer_no_show_remarks', consumer_no_show_remarks.value);
        }
        if (ClientCancelOnArrivalchecked) {
            formdata.append('cancel_reason', '102');
            let client_cancel_on_arrival_remarks = document.getElementById('client_cancel_on_arrival_remarks');
            formdata.append('cancel_remark', client_cancel_on_arrival_remarks.value);
        }
        if (isVerificationPage) {
            formdata.append("client_online_sign", "");
            formdata.append("assign_client_remarks", "");
        }
        else if (ClientSignchecked) {

            // Client signature cannot be obtained
            formdata.append("client_online_sign", "Yes");
            formdata.append("assign_client_remarks", clientSignatureReason);
    
        } else if (
            AssignmentCurrentPostStatus === 'Check In' &&
            AssignmentDetailsAry.service_type === "InPerson Interpretation" &&
            !ClientSignchecked &&
            clisigCanvas.current &&
            typeof clisigCanvas.current.isEmpty === "function" &&
            !clisigCanvas.current.isEmpty()
        ) {
        
            formdata.append(
                "client_online_sign",
                clisigCanvas.current
                    .getCanvas()
                    .toDataURL("image/png")
            );
        
            formdata.append("assign_client_remarks", "");
        
        } else {
        
            formdata.append("client_online_sign", "");
            formdata.append("assign_client_remarks", "");
        
        }

        //formdata.append('interpreter_sign', sigCanvas.current.getCanvas().toDataURL("image/png"));

        // Interpreter Signature
        //sched-1436-starts
        if (!UploadSignedVoucher) {
            formdata.append(
                'interpreter_sign',
                sigCanvas.current
                    .getCanvas()
                    .toDataURL("image/png")
            );
        }

        
        // if (
        //     !isVerificationPage &&
        //     AssignmentCurrentPostStatus === "Check In" &&
        //     !UploadSignedVoucher &&
        //     !ClientSignchecked &&
        //     clisigCanvas.current &&
        //     !clisigCanvas.current.isEmpty()
        // ) {

        //     formdata.append(
        //         "client_online_sign",
        //         clisigCanvas.current
        //             .getCanvas()
        //             .toDataURL("image/png")
        //     );

        // } else {

        //     formdata.append(
        //         "client_online_sign",
        //         ""
        //     );

        // }
        // sched-1436-ends

        
        ClientCancelOnArrivalchecked || (ClientCancelOnArrivalchecked && ConsumerNoShowchecked) ? 
        apiWithAuth.post(url_cancel_assignment, formdata, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                finalEndAssignmentButtonLoadingSet(false);  
                changeAssignStatus('CancelEnd');
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                finalEndAssignmentButtonLoadingSet(false);
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            finalEndAssignmentButtonLoadingSet(false);
            OpenSwal('Axios_error', response.message);
        })
        :
        apiWithAuth.post(url_change_assignment_status, formdata, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                finalEndAssignmentButtonLoadingSet(false);
                if (isVerificationPage) {

                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Service information has been submitted.',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/Interpreter/Action_list');
                        }
                    });
        
                } else {
                AssignmentEndPageDetailsSet({ ...AssignmentEndPageDetails, paperwork_path: response.data.paper_work_file_path });
                }
                changeAssignStatus('Completed');
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                finalEndAssignmentButtonLoadingSet(false);
                OpenSwal('Axios_error', response.data.message);
            }

        }).catch(response => {
            finalEndAssignmentButtonLoadingSet(false);
            OpenSwal('Axios_error', response.message);
        });
    }


    const ConsumerNoShowcheckedChange = (element) => {

        if (element.target.checked) {
            Swal.fire({
                title: "Consumer No Show",
                text: "Did the Consumer of Interpreting not show up to assignment?",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: '#5cb85c',
                cancelButtonText: "No",
                cancelButtonColor: 'red',
                reverseButtons: true,
                color: appThemeColor,
                // icon:'success'
            }).then((result) => {
                if (result.isConfirmed) {
                    ConsumerNoShowcheckedSet(true);
                } else {
                    ConsumerNoShowcheckedSet(false);
                }
            });

        } else {
            ConsumerNoShowcheckedSet(false);
        }
    }
    // sched-1436-starts
    const Clientsign = (event) => {

        const checked = event.target.checked;

        if (checked) {

            setClientSignchecked(true);

        } else {

            Swal.fire({
                title: "Enable Client Signature?",
                text: "The client signature will be required.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                confirmButtonColor: "#5cb85c",
                cancelButtonColor: "#d33",
                reverseButtons: true,
                color: appThemeColor
            }).then((result) => {

                if (result.isConfirmed) {

                    setClientSignchecked(false);
                    setClientSignatureReason("");

                } else {

                    setClientSignchecked(true);

                }
            });
        }
    };
    // sched-1436-ends

    const ClientCancelonArrivalcheckedChange = (element) => {

        if (element.target.checked) {
            Swal.fire({
                title: AssignmentCancelReasonCancellationCode,
                text: "Did the Client cancel the assignment on arrival?",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: '#5cb85c',
                cancelButtonText: "No",
                cancelButtonColor: 'red',
                reverseButtons: true,
                color: appThemeColor,
                // icon:'success'
            }).then((result) => {
                if (result.isConfirmed) {
                    ClientCancelOnArrivalcheckedSet(true);
                } else {
                    ClientCancelOnArrivalcheckedSet(false);
                }
            });

        } else {
            ClientCancelOnArrivalcheckedSet(false);
        }
    }

    useEffect(() => {
        if (AssignmentCurrentPostStatus === 'Lapsed') {
            endAssignmentStageSet('end_assignment_start');
        }
    }, [])


    const [rejectPopupOpen, setRejectPopupOpen] = useState(false);
const [rejectRemarks, setRejectRemarks] = useState('');
const [rejectButtonLoading, setRejectButtonLoading] = useState(false);

//const url_reject_interp_signature =
 //   "Interpreter_Controller/reject_interp_signature";

const handleReject = () => {
    setRejectRemarks('');
    setRejectPopupOpen(true);
};


const submitReject = () => {

    const remarks = rejectRemarks.trim();

    if (remarks === '') {
        OpenSwal('Axios_error', 'Please enter the remarks.');
        return;
    }

    setRejectButtonLoading(true);

    let payload = {
        assignid: assign_id,
        remarks: remarks,
        message_id: AssignmentDetailsAry?.message_id || ''
    };

    apiWithAuth.post(
        url_reject_interp_signature,
        payload,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    ).then(response => {

        const result = response.data.status_msg?.[0];

        console.log("Reject API Response:", response.data);
        console.log("Reject Result:", result);

        if (result?.status === true) {

            setRejectPopupOpen(false);
            setRejectRemarks('');
            setRejectButtonLoading(false);

            const successMessage = result.message
                ? atob(result.message)
                : 'Service Info rejected and submitted for the iTiLive Staff Review.';

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: successMessage,
                confirmButtonText: 'OK'
            }).then((swalResult) => {

                if (swalResult.isConfirmed) {
                    navigate('/Interpreter/Action_list');
                }

            });

            return;
        }

        if (
            result?.status === false &&
            result?.message === "Token Expired"
        ) {

            setRejectButtonLoading(false);

            OpenSwal(
                'Token_error',
                navigate
            );

            return;
        }

        setRejectButtonLoading(false);

        OpenSwal(
            'Axios_error',
            result?.message
                ? atob(result.message)
                : 'Unable to process the rejection.'
        );

    }).catch(error => {

        setRejectButtonLoading(false);

        console.log("Reject API Error:", error);

        OpenSwal(
            'Axios_error',
            error.response?.data?.message ||
            error.message ||
            'Unable to process the rejection.'
        );
    });
};


    return (

        <Box>
            <Box sx={{ mt: 2, mb: 10 }}>
                {endAssignmentStage === null && !isVerificationPage &&  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                    <Button variant="contained" size='small' sx={{ backgroundColor: '#89B601', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' } }} onClick={() => CheckEndAssignmentValid('end_check')} startIcon={<CheckCircleOutlineOutlinedIcon />}>End Assignment</Button>
                </Box >}

                <Box sx={{ display: (endAssignmentStage === 'end_assignment_start') ? 'block' : 'none' }}>

                    {AssignmentCurrentPostStatus === 'Lapsed' && <Box>


                        <Box  >

                            <Typography sx={{ typography: { xs: 'body2', sm: 'subtitle2' } }} color={appThemeColor}>Start Date & Time *</Typography>

                            <Box>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        slotProps={{ textField: { size: 'small', error: (AssignmentStartDateLapsedErrorMsg !== false), helperText: AssignmentStartDateLapsedErrorMsg, color: appThemeSecondaryColor, variant: 'outlined', fullWidth: true } }}

                                        value={AssignmentStartDateLapsed}
                                        onChange={(newValue) => {
                                            AssignmentStartDateLapsedSet(newValue);
                                            // AssignmentEndDateLapsedSet(null);
                                        }}
                                        // defaultValue={dayjs.tz(AssignmentDetailsAry.assign_start_time_validation)}
                                        // minDateTime={dayjs.tz(AssignmentDetailsAry.assign_start_time_validation)}
                                        minDateTime={
                                            AssignmentDetailsAry.assign_status === "Lapsed"
                                                ? dayjs.tz(
                                                      AssignmentDetailsAry.assign_requestdatetime,
                                                      AssignmentDetailsAry.assign_client_timezone
                                                  )
                                                : dayjs.tz(
                                                      AssignmentDetailsAry.assign_start_time_validation,
                                                      AssignmentDetailsAry.assign_client_timezone
                                                  )
                                        }        
                                        maxDateTime={dayjs(AssignmentEndDateLapsed).subtract('1', 'minute')}
                                        onError={(newError) => AssignmentStartDateLapsedErrorMsgSet(getDateTimePickerValidationMsg(newError))}
                                        // defaultValue={dayjs('2022-07-17')}
                                        timeSteps={{ minutes: 1 }}
                                        views={['year', 'month', 'day', 'hours', 'minutes']}
                                    // timezone={iti_user_timezone}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Box>

                        <Box mt={1} >

                            <Typography sx={{ typography: { xs: 'body2', sm: 'subtitle2' } }} color={appThemeColor}>End Date & Time *</Typography>

                            <Box>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        slotProps={{ textField: { size: 'small', error: (AssignmentEndDateLapsedErrorMsg !== false), helperText: AssignmentEndDateLapsedErrorMsg, color: appThemeSecondaryColor, variant: 'outlined', fullWidth: true } }}
                                        // defaultValue={dayjs.tz(new Date(dayjs().format('YYYY-MM-DD hh:mm A')))}
                                        value={AssignmentEndDateLapsed}
                                        onChange={(newValue) => {
                                            AssignmentEndDateLapsedSet(newValue);
                                        }}
                                        minDateTime={dayjs(AssignmentStartDateLapsed).add('1', 'minute')}
                                        // maxDateTime={dayjs.tz(new Date(dayjs().format('YYYY-MM-DD hh:mm A')))}
                                        disableFuture

                                        views={['year', 'month', 'day', 'hours', 'minutes']}
                                        timeSteps={{ minutes: 1 }}
                                        // timezone={iti_user_timezone}
                                        onError={(newError) => AssignmentEndDateLapsedErrorMsgSet(getDateTimePickerValidationMsg(newError))}
                                        disabled={AssignmentStartDateLapsed === null ? true : false}


                                    />
                                </LocalizationProvider>
                            </Box>
                        </Box>
                        {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box display='flex' alignItems='center' mt={1}>
                            <FormControlLabel control={<Checkbox size="small" color={appThemeSecondaryColor} onChange={(evt) => AssignmentTravelledStartedCheckboxStatusSet(evt.target.checked)} />}
                                label={<Box><Typography variant='body2' color={appThemeColor}>Use Interpreter provided travel details</Typography></Box>} />
                            <Tooltip arrow enterTouchDelay={0} title="Traveled distance and time will be calculated from interpreter address to Assignment Location based on Zip codes." placement="top" >
                                <InfoOutlinedIcon sx={{ fontSize: { xs: '13px', sm: '14px', md: '16px' }, ml: -1, cursor: 'pointer' }} />
                            </Tooltip>
                        </Box>}
                    </Box>}


                    {AssignmentCurrentPostStatus === 'Check In' && <Grid container spacing={1} sx={{ mt: 1 }} >
                        <Grid xs={12} sm={4} md={4}>
                            <Box> <Typography sx={{ typography: { xs: 'body2', sm: 'subtitle2' } }} color={appThemeColor}>When did the Assignment Complete? *</Typography> </Box>
                            <Box>
                                <RadioGroup row name="closure_type" value={closureType} onChange={(evt) => { ClosureType(evt) }}   >
                                    <FormControlLabel value="Scheduled" control={<Radio size="small" color={appThemeSecondaryColor} />} label={<Typography variant='body2' color={appThemeColor}>Scheduled End Date & Time</Typography>} />
                                    <FormControlLabel value="Now" control={<Radio size="small" color={appThemeSecondaryColor} />} label={<Typography variant='body2' color={appThemeColor}>Now</Typography>} />
                                    <FormControlLabel value="Other" control={<Radio size="small" color={appThemeSecondaryColor} />} label={<Typography variant='body2' color={appThemeColor}>Earlier</Typography>} />
                                </RadioGroup>
                                {closureTypeErrorMsg && <FormHelperText error={true}>Please choose Now or Earlier</FormHelperText>}
                            </Box>
                        </Grid>
                        <Grid xs={12} sm={4} md={4}>
                            <Box sx={{ display: (datetimePickerHideShow) ? 'block' : 'none' }}>
                                <Box>
                                    <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2' } }} color={appThemeColor}>Mention End Time of the Assignment *</Typography>
                                </Box>
                                <Box>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            error: datetimePickerErrorMsg !== false,
                                            helperText: datetimePickerErrorMsg,
                                            color: appThemeSecondaryColor,
                                            variant: "outlined",
                                            fullWidth: true
                                        }
                                    }}

                                    value={currentUserTime}

                                    onChange={(newValue) => {
                                        currentUserTimeSet(newValue);
                                    }}

                                    minDateTime={
                                        closureType === "Scheduled"
                                            ? undefined
                                            : dayjs(interpreter_start_time).add(1, "minute")
                                    }

                                    disableFuture

                                    timeSteps={{ minutes: 1 }}

                                    onError={(newError) => {

                                        if (closureType === "Scheduled") {
                                            datetimePickerErrorMsgSet(false);
                                        } else {
                                            datetimePickerErrorMsgSet(
                                                datetimePickerDisabled
                                                    ? false
                                                    : getDateTimePickerValidationMsg(newError)
                                            );
                                        }
                                    }}

                                    disabled={datetimePickerDisabled}

                                    views={['year', 'month', 'day', 'hours', 'minutes']}
                                />
                                    </LocalizationProvider>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>}



                    {/* {AssignmentDetailsAry.service_type === "InPerson Interpretation" && < Box sx={{ mt: 2 }}>



                        <Grid container spacing={{ xs: 0, sm: 1 }}   >
                            <Grid xs={12} sm={4} md={4}>
                                <Box>
                                    <Box> <Typography sx={{ typography: { xs: 'body2', sm: 'subtitle2' } }} color={appThemeColor}>Upload Voucher or assignment proof *</Typography> </Box>
                                    <Box> <Button component="label" color='inherit' role={undefined} sx={{ textTransform: 'none' }} startIcon={<CloudUploadIcon />} > Upload <input type="file" hidden id="assign_paper_work_file" onChange={assignPaperWorkFileUpload} /> </Button> </Box>
                                    {assignmentPaperWorkFileError !== 'ok' && <FormHelperText error={(assignmentPaperWorkFileError === false) ? false : true}>{(assignmentPaperWorkFileError === false) ? '.pdf,.png.jpg,.jpeg files only supported' : assignmentPaperWorkFileError}</FormHelperText>}
                                    {assignmentPaperWorkFileError === false && <FormHelperText error={(assignmentPaperWorkFileError === false) ? false : true}>Please ensure your file size does not exceed 10 MB.</FormHelperText>}

                                </Box>
                            </Grid>
                            <Grid xs={12} sm={4} md={4}>
                                {PaperWorkFilesData.blob !== null && <Box>
                                    <FileViewerCustom filename='Paper Work File' fileurl={PaperWorkFilesData.blob} exttype={PaperWorkFilesData.type} height={150} width='100%' color='#fff' />
                                </Box>}
                            </Grid>

                        </Grid>

                    </Box>} */}
                    {!isVerificationPage && (
                    <Box sx={{ mt: 1 }}>

                        <Grid container spacing={{ xs: 0, sm: 1 }}   >
                            <Grid xs={12} sm={4} md={4}>
                                <Box display='flex' alignItems='center' >


                                    <FormControlLabel control={<Checkbox size="small" color={appThemeSecondaryColor} onChange={ConsumerNoShowcheckedChange} id="consumer_no_show_checkbox" checked={ConsumerNoShowchecked} />}
                                        label={<Typography variant='body2' color={appThemeColor}>Consumer No Show  </Typography>} />

                                    <Tooltip arrow enterTouchDelay={0} title="When the person you are interpreting for does not show up to the assignment" placement="top" >
                                        <InfoOutlinedIcon sx={{ fontSize: { xs: '13px', sm: '14px', md: '16px' }, ml: -1, cursor: 'pointer' }} />
                                    </Tooltip>
                                </Box>
                            </Grid>
                            <Grid xs={12} sm={4} md={4}>
                                <Box sx={{ display: (ConsumerNoShowchecked) ? 'block' : 'none' }}>

                                    <Box>
                                        <TextField
                                            id="consumer_no_show_remarks" label="Consumer No Show Remarks" multiline rows={4} required size='small' error={(ConsumerNoShowErrorMsg) ? true : false}
                                            helperText={ConsumerNoShowErrorMsg && ConsumerNoShowErrorMsg} color={appThemeSecondaryColor} fullWidth

                                        />
                                    </Box>


                                </Box>

                            </Grid>

                            <Grid xs={12} sm={4} md={4}>
                                    <Box display='flex' alignItems='center'>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    color={appThemeSecondaryColor}
                                                    onChange={ClientCancelonArrivalcheckedChange}
                                                    id="client_cancel_on_arrival_checkbox"
                                                    checked={ClientCancelOnArrivalchecked}
                                                />
                                            }
                                            label={<Typography variant='body2' color={appThemeColor}>{AssignmentCancelReasonCancellationCode} </Typography>}
                                        />
                                        <Tooltip
                                            arrow
                                            enterTouchDelay={0}
                                            title={`When the person you are interpreting for cancels the assignment when you arrive at location`}
                                            placement="top"
                                        >
                                            <InfoOutlinedIcon sx={{ fontSize: { xs: '13px', sm: '14px', md: '16px' }, ml: -1, cursor: 'pointer' }} />
                                        </Tooltip>
                                    </Box>
                            </Grid>
                            
                            <Grid xs={12} sm={4} md={4}>
                                <Box sx={{ display: (ClientCancelOnArrivalchecked) ? 'block' : 'none' }}>
                                    <Box>
                                        <TextField
                                            id="client_cancel_on_arrival_remarks"
                                            label="Cancel Remarks"
                                            multiline
                                            rows={4}
                                            required
                                            size='small'
                                            error={!!ClientCancelOnArrivalErrorMsg}
                                            helperText={ClientCancelOnArrivalErrorMsg && ClientCancelOnArrivalErrorMsg}
                                            color={appThemeSecondaryColor}
                                            fullWidth
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
 
                    </Box>
                    )
                }
                    <Box sx={{ mt: 3 }}>

                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant="contained" sx={{ backgroundColor: '#89B601', color: '#fff', textTransform: 'none', '&:hover': { backgroundColor: '#5f7f00' }, width: '250px' }} endIcon={<ArrowForwardOutlinedIcon />} onClick={endAssignmentNext}>Next</Button>
                        </Box>

                    </Box>
                </Box>

                {/* 
                {endAssignmentStage === "end_assignment_qrcode_manual" && <Box>
                    <Box>
                        <Box> <Typography variant='caption' color={appThemeColor} sx={{ letterSpacing: '-0.5px' }}>To Modify the Assignment End Time / Closure Type ?</Typography> </Box>
                        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'left', md: 'left' }, ml: { xs: 0, sm: 1, md: 1 }, mt: 1 }}>
                            <Button variant="contained" size='small' sx={{ backgroundColor: '#89B601', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' }, width: '150px' }} onClick={() => CheckEndAssignmentValid('go_back')} startIcon={<KeyboardBackspaceIcon />}>Go Back</Button>
                        </Box >
                        <Box sx={{ mt: 1 }}> <Typography variant='caption' color={appThemeColor} sx={{ letterSpacing: '-0.5px' }}>Or End the Assignment </Typography> </Box>
                        <Box sx={{ ml: { xs: 0, sm: 1, md: 1 } }}>
                            <Grid container spacing={{ xs: 1, sm: 3, md: 6 }} >
                                <Grid xs={6} sm={5} md={3} lg={2} >
                                    <Card sx={{ backgroundColor: '#c0c1bd', borderRadius: '2px', height: '100px', width: { xs: '100%' } }}>
                                        <CardContent >
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                                <QrCodeScannerIcon sx={{ color: 'white' }} fontSize='large' />
                                            </Box>
                                            <Typography variant='body1' align='center' color='white' >QR-Code</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid xs={6} sm={5} md={3} lg={2}>
                                    <Card onClick={() => endAssignmentStageSet('end_assignment_manual_final')} sx={{ backgroundColor: '#89B601', borderRadius: '2px', height: '100px', width: { xs: '100%' }, cursor: 'pointer' }}>
                                        <CardContent >
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                                <ModeEditOutlineIcon sx={{ color: 'white' }} fontSize='large' />
                                            </Box>
                                            <Typography variant='body1' align='center' color='white' >Manual</Typography>
                                        </CardContent>
                                    </Card> </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>} */}
                {(endAssignmentStage === "end_assignment_manual_final" || isVerificationPage) && <Box>


                    <Box>


                        {/* <Box sx={{ mt: 1, ml: { xs: 0, sm: 1 } }}> <Typography variant='subtitle1' color={appThemeColor} sx={{ letterSpacing: '-0.5px' }}>Reason for Manual Checkout</Typography> </Box>



                        <Grid container spacing={2} sx={{ mt: 1 }} >
                            <Grid xs={12} sm={6} md={6}>
                                <Box>

                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="manual_reason_select_label" ><Typography color={appThemeColor}>Choose Reason*</Typography></InputLabel>
                                        <Select
                                            labelId="manual_reason_select_label" id="manual_reason_select" value={ManualCompletetionSelectValue}
                                            label="Choose Reason*" onChange={(evt) => manualReasonSelect(evt)} color={appThemeSecondaryColor}

                                            error={(manualCompletionRemarksErrormsg) ? true : false}  >

                                            <MenuItem value='Client Not Available'>Client Not Available</MenuItem>
                                            <MenuItem value='Client Busy'>Client Busy</MenuItem>
                                            <MenuItem value='QR Scan Not Working'>QR Scan Not Working</MenuItem>
                                            <MenuItem value='Others'>Others</MenuItem>
                                        </Select>
                                        {manualCompletionRemarksErrormsg && <FormHelperText error={true}>Please choose reason</FormHelperText>}
                                    </FormControl>

                                </Box>
                            </Grid>
                            <Grid xs={12} sm={6} md={6}>
                                <Box sx={{ display: (manualCompletionRemarksShowHide) ? 'block' : 'none' }}>
                                    <TextField fullWidth
                                        id="manual_reason_other_remarks" label="Mention reason here" multiline rows={3} required error={(manualCompletionOtherRemarksErrormsg) ? true : false}
                                        helperText={manualCompletionOtherRemarksErrormsg && 'Remarks Required'} color={appThemeSecondaryColor}
                                    />
                                </Box>

                            </Grid>

                        </Grid> */}

{!UploadSignedVoucher && (
                            <>


                                {/* sched-1436-starts */}

                                {AssignmentCurrentPostStatus === 'Check In' && 
                                 AssignmentDetailsAry.service_type === "InPerson Interpretation" && (
                                    <Grid xs={12} sm={4} md={4}>
                                        <Box display="flex" alignItems="center">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        color={appThemeSecondaryColor}
                                                        onChange={Clientsign}
                                                        id="Clientsign_checkbox"
                                                        checked={ClientSignchecked}
                                                    />
                                                }
                                                label={
                                                    <Typography
                                                        variant="body2"
                                                        color={appThemeColor}
                                                    >
                                                        Client Signature Cannot be Obtained
                                                    </Typography>
                                                }
                                            />

                                            <Tooltip
                                                arrow
                                                enterTouchDelay={0}
                                                title="Client signature required"
                                                placement="top"
                                            >
                                                <InfoOutlinedIcon
                                                    sx={{
                                                        fontSize: {
                                                            xs: '13px',
                                                            sm: '14px',
                                                            md: '16px'
                                                        },
                                                        ml: -1,
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                )}
                                {ClientSignchecked && (

                                    <FormControl
                                        fullWidth
                                        size="small"
                                        error={!!clientSignatureReasonError}
                                    >
                                        {/* <InputLabel>Client Signature Exception</InputLabel> */}

                                        <Select
                                            value={clientSignatureReason}
                                            displayEmpty
                                            onChange={(e) => {
                                                setClientSignatureReason(e.target.value);
                                                setClientSignatureReasonError("");
                                            }}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return (
                                                        <Typography color="text.secondary">
                                                            Select Reason
                                                        </Typography>
                                                    );
                                                }
                                                return selected;
                                            }}
                                        >
                                            {/* <MenuItem value="">
                                                <em>Select Reason</em>
                                            </MenuItem> */}
                                            <MenuItem value="Client Not Available to Sign">
                                                Client Not Available to Sign
                                            </MenuItem>
                                            <MenuItem value="Client Refused to Sign">
                                                Client Refused to Sign
                                            </MenuItem>

                                           {/* <MenuItem value="Client Signature Not Required as per Protocol">
                                                Client Signature Not Required as per Protocol
                                            </MenuItem>*/}

                                            
                                        </Select>

                                        <FormHelperText>
                                            {clientSignatureReasonError}
                                        </FormHelperText>
                                    </FormControl>

                                )}

                                {AssignmentCurrentPostStatus === 'Check In' &&
                                AssignmentDetailsAry.service_type === "InPerson Interpretation" &&
                                    !ClientSignchecked && (
                                        <>
                                        <Box sx={{ mt: 0, mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                    Client Name<span style={{ color: 'red' }}>*</span>
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    value={clientCustomerName}
                                                    onChange={(e) => {
                                                        setClientCustomerName(e.target.value);
                                                        setClientCustomerNameError(false);
                                                    }}
                                                    error={clientCustomerNameError}
                                                    helperText={
                                                        clientCustomerNameError
                                                            ? "Please enter the Client name."
                                                            : ""
                                                    }
                                                    disabled={finalEndAssignmentButtonLoading}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    mt: { xs: 0, sm: 2 }
                                                }}
                                            >
                                                <Typography variant="subtitle1">
                                                    Signature of Client *

                                                    <IconButton
                                                        onClick={clisignatureCanvasClear}
                                                        title="Clear"
                                                    >
                                                        <DeleteSweepOutlinedIcon
                                                            sx={{ color: 'red' }}
                                                        />
                                                    </IconButton>
                                                </Typography>
                                            </Box>

                                            <Grid container>
                                                <Grid xs={12} sm={6}>
                                                    <Box
                                                        sx={{
                                                            border: '2px solid #9f9f9f',
                                                            height: '150px',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <SignatureCanvas
                                                            penColor="black"
                                                            backgroundColor="rgba(0,0,0,0)"
                                                            clearOnResize={false}
                                                            ref={clisigCanvas}
                                                            canvasProps={{
                                                                className: 'clisigCanvas',
                                                                style: {
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    touchAction: 'pan-y',
                                                                    userSelect: 'none',
                                                                    WebkitUserSelect: 'none',
                                                                    WebkitTouchCallout: 'none',
                                                                    pointerEvents: finalEndAssignmentButtonLoading ? 'none' : 'auto'

                                                                }
                                                            }}
                                                        />
                                                    </Box>

                                                    {clisignatureEmptyError && (
                                                        <FormHelperText error>
                                                            Client Signature Required
                                                        </FormHelperText>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}

                                {/* sched-1436-ends */}


                       {/* Interpreter Signature */}

                       <Box
                                    sx={{
                                        mt: { xs: 0, sm: 2 },
                                        display: 'flex',
                                        justifyContent: { xs: 'center', sm: 'left' }
                                    }}
                                >
                                    <Typography variant="subtitle1" sx={{ letterSpacing: '-0.5px' }}>
                                        Signature of Interpreter *

                                        <IconButton onClick={signatureCanvasClear} title="clear">
                                            <DeleteSweepOutlinedIcon sx={{ color: 'red' }} />
                                        </IconButton>
                                    </Typography>
                                </Box>

                                <Grid container>
                                    <Grid xs={12} sm={5.9} md={5.9} lg={5.95}>
                                        <Box
                                            sx={{
                                                border: '2px solid #9f9f9f',
                                                height: '150px',
                                                borderRadius: '6px'
                                            }}
                                        >
                                            <SignatureCanvas
                                                penColor="black"
                                                backgroundColor="rgba(0,0,0,0)"
                                                clearOnResize={false}
                                                ref={sigCanvas}
                                                canvasProps={{
                                                    className: 'sigCanvas',
                                                    style: {
                                                        width: '100%',
                                                        height: '100%',
                                                        borderRadius: '4px',
                                                        touchAction: 'pan-y',
                                                        userSelect: 'none',
                                                        WebkitUserSelect: 'none',
                                                        WebkitTouchCallout: 'none',
                                                        pointerEvents: finalEndAssignmentButtonLoading ? 'none' : 'auto'
                                                    }
                                                }}
                                            />
                                        </Box>

                                        {signatureEmptyError && (
                                            <FormHelperText error>
                                                Signature Required
                                            </FormHelperText>
                                        )}
                                    </Grid>
                                </Grid>
                            </>
                        )}
                        <Box mt={3}>
                            {finalEndAssignmentButtonLoading && <Typography color='error' align='center'> Please do not refresh or go back until process completed</Typography>}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                        {!isVerificationPage && ( <Button variant="contained" color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, color: '#fff', textTransform: 'none' }} onClick={() => CheckEndAssignmentValid('go_back')} startIcon={<KeyboardBackspaceIcon />} disabled={finalEndAssignmentButtonLoading}>Back</Button>)}
                        {isVerificationPage && (
    <Button
        variant="contained"
        color="error"
        onClick={handleReject}
        disabled={rejectButtonLoading}
        sx={{
            textTransform: 'none',
            minWidth: '100px'
        }}
    >
        {rejectButtonLoading ? 'Processing...' : 'Reject'}
    </Button>
)}
                            <LoadingButton variant="contained" sx={{ backgroundColor: '#89B601', color: '#fff', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' }, textTransform: 'none', ml: 1 }} loadingPosition="center" endIcon={<CheckCircleOutlineOutlinedIcon />} onClick={endAssignmentFinal} loading={finalEndAssignmentButtonLoading} >Submit</LoadingButton>
                        </Box>


                        <Dialog
    open={rejectPopupOpen}
    onClose={() => {
        if (!rejectButtonLoading) {
            setRejectPopupOpen(false);
        }
    }}
    fullWidth
    maxWidth="sm"
>
    <DialogTitle>
        Reject Service Information
    </DialogTitle>

    <DialogContent>
        <TextField
            autoFocus
            fullWidth
            multiline
            rows={5}
            label="Remarks"
            placeholder="Enter rejection remarks"
            value={rejectRemarks}
            onChange={(e) => setRejectRemarks(e.target.value)}
            disabled={rejectButtonLoading}
            sx={{ mt: 1 }}
        />
    </DialogContent>

    <DialogActions>
        <Button
            onClick={() => setRejectPopupOpen(false)}
            disabled={rejectButtonLoading}
            sx={{ textTransform: 'none' }}
        >
            Cancel
        </Button>

        <Button
            variant="contained"
            color="error"
            onClick={submitReject}
            disabled={rejectButtonLoading || !rejectRemarks.trim()}
            sx={{ textTransform: 'none' }}
        >
            {rejectButtonLoading ? 'Processing...' : 'Submit Rejection'}
        </Button>
    </DialogActions>
</Dialog>

                    </Box>
                </Box>}

            </Box>

        </Box >

    )
}

export default AssignmentEndPage1